import type {Category} from 'shells/categorized-select-list/categorized-select-list';

import type {GetLandingPageStarters_pageStarters as PageStarter} from 'nutshell-graphql-types';

import type {StarterOption} from './start-from-page-selection-modal';

/**
 * Takes a list of pageStarters and returns them as a list of Category<StarterOption>, with the first
 * category in the list including the "Templates" label.
 *
 * @param pageStarters
 * @returns {Category<StarterOption>[]}
 */
export const categorizeLandingPageStarters = (
    pageStarters: PageStarter[]
): Category<StarterOption>[] => {
    const categories: Category<StarterOption>[] = [];

    pageStarters.forEach((pageStarter) => {
        const existingCategory = categories.find(
            (category) => category.id === pageStarter.categoryId
        );

        if (existingCategory && existingCategory.collection) {
            existingCategory.subtitle = `${existingCategory.collection.length + 1} pages`;
            existingCategory.collection.push({
                id: pageStarter.id,
                templatePage: {
                    name: pageStarter.name,
                    thumbnailUrl: pageStarter.thumbnailUrl,
                    backgroundColor: pageStarter.backgroundColor,
                },
            });
        } else {
            categories.push({
                id: pageStarter.categoryId,
                title: pageStarter.categoryName,
                subtitle: '1 page',
                ...(categories.length === 0 ? {label: 'Templates'} : {}),
                collection: [
                    {
                        id: pageStarter.id,
                        templatePage: {
                            name: pageStarter.name,
                            thumbnailUrl: pageStarter.thumbnailUrl,
                            backgroundColor: pageStarter.backgroundColor,
                        },
                    },
                ],
            });
        }
    });

    return categories;
};
